(() => {
  const updateScrollState = () => {
    document.body.classList.toggle('hr3d-scrolled', window.scrollY > 32);
  };

  let frameRequested = false;
  const onScroll = () => {
    if (frameRequested) return;

    frameRequested = true;
    window.requestAnimationFrame(() => {
      updateScrollState();
      frameRequested = false;
    });
  };

  updateScrollState();
  window.addEventListener('scroll', onScroll, { passive: true });

  const motionAllowed =
    document.body.dataset.hr3dEffects === 'true' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!motionAllowed) return;

  document.documentElement.classList.add('hr3d-motion-ready');

  const revealSelector = [
    '.hr3d-section-head',
    '.hr3d-panel',
    '.hr3d-category',
    '.card-wrapper',
    '.product__media-wrapper',
    '.product__info-wrapper',
    '.rich-text__blocks',
    '.collapsible-content__wrapper',
  ].join(',');

  const observedElements = new WeakSet();
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('hr3d-reveal--visible');
        revealObserver.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  const registerRevealElements = (root = document) => {
    root.querySelectorAll(revealSelector).forEach((element, index) => {
      if (observedElements.has(element)) return;
      observedElements.add(element);
      element.classList.add('hr3d-reveal');
      element.style.setProperty('--hr3d-reveal-delay', `${(index % 4) * 70}ms`);
      revealObserver.observe(element);
    });
  };

  registerRevealElements();
  document.addEventListener('shopify:section:load', (event) => registerRevealElements(event.target));

  const hero = document.querySelector('.hr3d-hero');
  const logo = hero?.querySelector('.hr3d-hero__logo');
  if (!hero || !logo || !window.matchMedia('(pointer: fine)').matches) return;

  hero.addEventListener(
    'pointermove',
    (event) => {
      const bounds = hero.getBoundingClientRect();
      const horizontal = (event.clientX - bounds.left) / bounds.width - 0.5;
      const vertical = (event.clientY - bounds.top) / bounds.height - 0.5;
      logo.style.setProperty('--hr3d-parallax-x', `${horizontal * -14}px`);
      logo.style.setProperty('--hr3d-parallax-y', `${vertical * -10}px`);
    },
    { passive: true }
  );

  hero.addEventListener('pointerleave', () => {
    logo.style.removeProperty('--hr3d-parallax-x');
    logo.style.removeProperty('--hr3d-parallax-y');
  });
})();
